//Packages
import { Routes, Route, useLocation, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

//Components
import Header from "./components/Header";
import Footer from "./components/Footer";

//Pages
import Home from "./pages/Home.jsx";
import AboutUs from "./pages/AboutUs";
import BlogDetails from "./pages/BlogDetails";
import BlogOne from "./pages/BlogOne";
import BlogTwo from "./pages/BlogTwo";
import CaseStudy from "./pages/CaseStudy";
import CaseStudyDetails from "./pages/CaseStudyDetails";
import CaseStudyVideos from "./pages/CaseStudyVideos";
import SectorDetails from "./pages/SectorDetails";
import ContactOne from "./pages/ContactOne";
import ContactTwo from "./pages/ContactTwo";
import Faq from "./pages/Faq";
import HomeTwo from "./pages/HomeTwo";
import HomeThree from "./pages/HomeThree";
import HomeFour from "./pages/HomeFour";
import HomeFive from "./pages/HomeFive";
import PageNotFound from "./pages/PageNotFound";
import Pricing from "./pages/Pricing";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BookConsultation from "./pages/BookConsultation";
import AaerLegalTechnology from "./pages/AaerLegalTechnology";

import initMagnetCursor from "./Utils/magnet-cursor.js";
import initActiveScripts, { resetMobileMenuState } from "./Utils/active.js";
import { setupMobileMenuClickOutside } from "./Utils/mobileMenuUtils.js";

function LayoutWrapper({ children }) {
  const location = useLocation();
  const { pathname } = location;

  // Pages to skip Header
  const headerSkipRoutes = ["/hometwo", "/homethree", "/homefour", "/homefive"];

  // Pages to skip Footer
  const footerSkipRoutes = ["/hometwo", "/homefour"];

  const showHeader = !headerSkipRoutes.includes(pathname);
  const showFooter = !footerSkipRoutes.includes(pathname);

  useEffect(() => {
    initMagnetCursor();
    initActiveScripts();
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Initialize click outside handler for mobile menu
    const cleanupClickOutside = setupMobileMenuClickOutside();

    // Add global click listener for navigation links to close mobile menu
    const handleGlobalNavClick = (event) => {
      const target = event.target;
      if (target.tagName === "A" && target.href && !target.href.includes("#")) {
        // This is a navigation link, close mobile menu
        setTimeout(() => {
          resetMobileMenuState();
        }, 100);
      }
    };

    document.addEventListener("click", handleGlobalNavClick);

    return () => {
      cleanupClickOutside();
      document.removeEventListener("click", handleGlobalNavClick);
    };
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    initMagnetCursor(); // reinitialize on every route
    initActiveScripts(); // reinitialize on every route to fix mobile menu
  }, [location.pathname]);

  // Enhanced mobile menu reset on route change
  useEffect(() => {
    // Reset mobile menu state when route changes
    // Use a shorter timeout to ensure it happens quickly
    const timer = setTimeout(() => {
      resetMobileMenuState();
    }, 50);

    // Also reset immediately for better responsiveness
    resetMobileMenuState();

    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <>
      {showHeader && <Header />}
      {children}
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/aaer-legal-technology" element={<AaerLegalTechnology />} />
          <Route path="/blogdetails" element={<BlogDetails />} />
          <Route path="/blogone" element={<BlogOne />} />
          <Route path="/blogtwo" element={<BlogTwo />} />
          <Route path="/casestudy" element={<CaseStudy />} />
          <Route path="/case-studies" element={<CaseStudyVideos />} />
          <Route path="/sectors" element={<CaseStudy />} />
          <Route path="/casestudydetails" element={<CaseStudyDetails />} />
          <Route path="/sectordetails" element={<SectorDetails />} />
          <Route path="/contactone" element={<ContactOne />} />
          <Route path="/bookconsultation" element={<BookConsultation />} />
          <Route path="/contacttwo" element={<ContactTwo />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/hometwo" element={<HomeTwo />} />
          <Route path="/homethree" element={<HomeThree />} />
          <Route path="/homefour" element={<HomeFour />} />
          <Route path="/homefive" element={<HomeFive />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/service" element={<Service />} />
          <Route path="/servicedetails" element={<ServiceDetails />} />
          <Route path="/team" element={<Team />} />
          <Route path="/teamdetails" element={<TeamDetails />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/header" element={<Header />} />
          <Route path="/footer" element={<Footer />} />

          {/* Catch-all route for 404 */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </LayoutWrapper>
    </BrowserRouter>
  );
}

export default App;
